const eurFmt = new Intl.NumberFormat('hu-HU', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 2,
})

const numFmt = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 2 })

export function fmtEur(value: string | number | null | undefined): string {
  if (value == null || value === '') return '—'
  const n = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(n)) return '—'
  return eurFmt.format(n)
}

export function fmtNum(value: string | number | null | undefined, digits = 2): string {
  if (value == null || value === '') return '—'
  const n = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('hu-HU', { maximumFractionDigits: digits }).format(n)
}

export function fmtPct(value: number | string | null | undefined, digits = 1): string {
  if (value == null || value === '') return '—'
  const n = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(n)) return '—'
  return `${n.toFixed(digits)}%`
}

export function fmtDate(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('hu-HU')
}

export function fmtDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('hu-HU', { dateStyle: 'short', timeStyle: 'short' })
}

export { numFmt }
